import gql from 'graphql-tag';

export const PEOPLE_EMPLOYEE_HISTORY_FRAGMENT = gql`
	fragment peopleEmployeeHistory on DocumentHistory {
		id
		created
		content
		model
		parentModel
		parentDocument
		creator {
			id
			firstname
			lastname
			destroyed
		}
	}
`;

export const GET_EMPLOYEE_HISTORY = gql`
	query(
		$employeeId: ID!,
		$page: Int,
		$perPage: Int,
		$sortDirection: Int!,
		$field: String
	) {
		getEmployeeHistory(
			employeeId: $employeeId,
			page: $page,
			perPage: $perPage,
			sortDirection: $sortDirection,
			field: $field
		) {
			items {
				...peopleEmployeeHistory
			}
			count
		}
	}
	${PEOPLE_EMPLOYEE_HISTORY_FRAGMENT}
`;

